"use client";

import { createContext, useContext } from "react";

export interface ThemeContextValue {
	theme: string;
	setTheme: (theme: string) => void;
	resolvedTheme: string;
	themes: string[];
	systemTheme?: string;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(
	undefined,
);

export function useTheme(): ThemeContextValue {
	const context = useContext(ThemeContext);
	if (!context) {
		return {
			theme: "dark",
			setTheme: () => {},
			resolvedTheme: "dark",
			themes: ["light", "dark", "system"],
		};
	}
	return context;
}
